var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Injectable } from "@angular/core";
import { AbstractHttpService } from "../http/abstract-http.service";
import { JwtHttpClientService } from "../http/jwt-http-client.service";
/**
 * Retrieves images from the server
 */
export class ImageService extends AbstractHttpService {
    constructor(http) {
        super();
        this.http = http;
    }
    getImage(imageId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.http.get(ImageService.URL + imageId.toString())
                .map((response) => response.text() || {})
                .catch((response) => this.handleServiceError(response))
                .toPromise();
        });
    }
    lazyLoadImage(image) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!image || !image.id) {
                return undefined;
            }
            if (image.image === undefined) {
                const imageId = image.id;
                image.image = null; // Avoid concurrent reloading - note that this may wipe image.id
                image.image = yield this.getImage(imageId);
                if (image.image) {
                    image.id = imageId;
                }
                else {
                    image.id = undefined;
                }
            }
            return image.image;
        });
    }
}
ImageService.URL = "/dataserver/image/";
ImageService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
ImageService.ctorParameters = () => [
    { type: JwtHttpClientService, },
];
//# sourceMappingURL=image.service.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fedelta-pos/data-client/image/image.service.js
// module id = 423
// module chunks = 1